<template>
  <div>
    <h1>QR Unmatched</h1>
    <hr>

    <!-- FILTER STARTS -->
    <flexibleFilter
      :dealer_type="'DEALER'"
      :fetch_filter="fetchFilter"
      @onFilter="setFilterUrl"
    ></flexibleFilter>
    <!-- FILTER ENDS -->

    <!-- QR Replacement By Date Start -->
    <div class="innerBox mt-5">
      <h5 class="mb-2">QR Unmatched By Date</h5>
      <qr-replacement-by-date
        :filterUrl="filterUrl"
      ></qr-replacement-by-date>
    </div>
    <!-- QR Replacement By Date End -->

    <!-- QR Replacement By Reason Start -->
    <!-- <div class="innerBox mt-5">
      <h5 class="mb-2">QR Replacement By Reason</h5>
      <qr-replacement-by-reason
        :filterUrl="filterUrl"
      ></qr-replacement-by-reason>
    </div> -->
    <!-- QR Replacement By Reason End -->
  </div>
</template>

<script>
  import flexibleFilter from '@/components/filter/flexible_filter.vue'

  import qrReplacementByDate from './children/qrReplacementByDate'
  // import qrReplacementByReason from './children/qrReplacementByReason'

  export default {
    data () {
      return {
        filterUrl : '',
        fetchFilter : 0,
      }
    },
    components : {
      flexibleFilter,
      qrReplacementByDate,
      // qrReplacementByReason,
    },
    mounted () {
      this.fetchFilter++;
    },
    methods : {
      setFilterUrl(a){
        this.filterUrl = a
      }
    }
  }
</script>

<style scoped>
  
</style>